var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCutPizza = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_282_2424)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.66663C11.24 2.66663 6.97334 4.71996 4.01334 7.99996L16 29.3333L27.9867 7.99996C25.04 4.73329 20.76 2.66663 16 2.66663ZM16 23.8933L7.34667 8.47996C9.76 6.46663 12.8267 5.33329 16 5.33329C19.1733 5.33329 22.24 6.46663 24.6533 8.47996L16 23.8933ZM12 7.33329C10.8933 7.33329 10 8.22663 10 9.33329C10 10.44 10.8933 11.3333 12 11.3333C13.1067 11.3333 14 10.44 14 9.33329C14 8.22663 13.0933 7.33329 12 7.33329ZM14 17.3333C14 18.44 14.8933 19.3333 16 19.3333C17.0933 19.3333 18 18.44 18 17.3333C18 16.2266 17.0933 15.3333 16 15.3333C14.9067 15.3333 14 16.2266 14 17.3333Z",
    fill: "#ED3D46"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_282_2424"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCutPizza);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CutPizza.409aa70822abcf042a2688ae1c9def67.svg";